import { Permission, rolesPermissionMap } from "@/utils/permissions";
import store, { AppGetters } from "@/store";

export const permissionMixin = {
  methods: {
    hasPermissions(permissions: Permission[]): boolean {
      const userRole = (store.getters as AppGetters).userRole;
      if (userRole) {
        const permissionsByRole = rolesPermissionMap.get(userRole) || [];
        return permissions.reduce((boolAcc: boolean, tmp: Permission) => {
          return (
            boolAcc && permissionsByRole.findIndex(per => per === tmp) !== -1
          );
        }, true);
      }
      return false;
    }
  }
};
